<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
          <router-link
            :to="{ name: 'campaigns.create' }"
            v-if="$allowedRoute('campaigns.create')"
          >
            <b-button block variant="primary" outline size="lg">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter campaign name"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Filter by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedStatus"
                          :options="statusOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select status</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="role === 'sales_manager'">
                <b-col>
                  <b-row>
                    <b-col>
                      <h5>Filter by user</h5>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <v-select
                        multiple
                        :closeOnSelect="false"
                        v-model="selectedUserIds"
                        :reduce="(user) => user.id"
                        label="email"
                        :options="users"
                      ></v-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                data-cy="campaign-table"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(owner)="data">
                  <Avatar
                    :imageUrl="data.item.owner.avatar_url"
                    :backgroundColor="data.item.owner.avatar_color"
                    :initials="data.item.owner.initials"
                    :small="true"
                  />
                </template>
                <template v-slot:cell(name)="data">
                  <router-link
                    v-if="$allowedRoute('campaigns.detail') && userId === data.item.owner.id"
                    :to="{
                      path: `/campaigns/${data.item.id}${
                        data.item.status === 'DRAFT' ? '/edit' : ''
                      }`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)" class="p-0 text-left">
                      {{ data.value }}
                    </b-button>
                  </router-link>
                  <h6 v-else>{{ data.value }}</h6>
                </template>
                <template v-slot:cell(status)="data">
                  <CampaignStatusBadge :status="data.value" />
                </template>
                <template v-slot:cell(number_of_clicks)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(number_of_opens)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(ctr)="data"
                  >{{ (data.value * 100).toFixed(0) }} %</template
                >
                <template v-slot:cell(open_rate)="data"
                  >{{ (data.value * 100).toFixed(0) }} %</template
                >
                <template v-slot:cell(sent_at)="data">{{
                  data.value | formatDate | notAvailable
                }}</template>
                <template v-slot:cell(template_name)="data">
                   <router-link
                    target='_blank'
                    v-if="$allowedRoute('templates.edit') && data.item.template_id"
                    :to="{
                      path: `/templates/${data.item.template_id}/edit`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)" class="p-0">
                      {{ data.item.template_name }}
                    </b-button>
                  </router-link>
                  <h6 v-else>{{ data.item.template_name | '-' }}</h6>
                </template>
                <template v-slot:cell(external_link)="data">
                  <a
                    v-if="data.value"
                    :href="data.value"
                    target="_blank"
                    class="external-link"
                    >LINK</a
                  ></template
                >
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
      <b-modal
        id="delete-modal"
        :visible="!!toDeleteItem"
        title="Delete list"
        @hidden="toDeleteItem = null"
      >
        <p>
          Campaign
          <strong>{{
            toDeleteCampaign ? `${toDeleteCampaign.name}` : null
          }}</strong>
          will be deleted.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteItem = null"
            >Cancel</b-button
          >
          <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import CampaignStatusBadge from "./Components/CampaignStatusBadge";
import { core } from "../../config/pluginInit";
import DeletedBadge from "./Components/DeletedBadge";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
import {getOwnerData} from "../../Utils/getOwnerData";
import Avatar from "./Components/Avatar.vue";

const LIST_CAMPAIGNS = gql`
  query listCampaigns(
    $where: campaigns_bool_exp!
    $order_by: [campaigns_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    campaigns_aggregate(order_by: $order_by, where: $where) {
      aggregate {
        totalCount: count
      }
    }
    campaigns(
      limit: $limit
      offset: $offset
      order_by: $order_by
      where: $where
    ) {
      id
      name
      status
      number_of_clicks
      ctr
      number_of_opens
      open_rate
      sent_at
      audience
      external_link
      template {
        id
        name
      }
      owner {
        id
        first_name
        last_name
        email
        avatar_url
        avatar_color
      }
    }
  }
`;
const DELETE_CAMPAIGN = gql`
  mutation deleteCampaign($id: uuid!) {
    update_campaigns_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_at: "now()" }
    ) {
      id
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query getMySalesPersons($adminId: uuid!){
    users (
      where: {
        role: {
          _eq: sales_person
        }
        organizations: {
          organization: {
            admin_id: {
              _eq: $adminId
            }
          }
        }
      }
    ){
      id
      email
      first_name
      last_name
    }
  }
`;
export default {
  name: "Campaigns",
  components: {
    CampaignStatusBadge,
    DeletedBadge,
    Avatar
  },
  data() {
    return {
      sortBy: "sent_at",
      sortDesc: true,
      campaigns: [],
      search: "",
      rows: null,
      perPage: 25,
      currentPage: 1,
      error: false,
      loading: false,
      selectedStatus: null,
      role: getAccountSync()?.defaultRole,
      userId: getAccountSync()?.userId,
      statusOptions: [
        {
          value: "DRAFT",
          text: "draft"
        },
        {
          value: "TO_SEND",
          text: "to send"
        },
        {
          value: "SENDING",
          text: "sending"
        },
        {
          value: "SENT",
          text: "sent"
        },
        {
          value: "ERROR",
          text: "error"
        }
      ],
      fields: [
        { key: "owner", label: "Owner", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "audience", label: "Audience", sortable: true },
        { key: "number_of_clicks", label: "Clicks", sortable: true },
        { key: "number_of_opens", label: "Opens", sortable: true },
        { key: "ctr", label: "CTR", sortable: true },
        { key: "open_rate", label: "OR", sortable: true },
        { key: "sent_at", label: "Sent at", sortable: true },
        { key: "template_name", label: "Template", sortable: false },
        // { key: "action", label: "Action", sortable: false },
        { key: "external_link", label: "Ext.link", sortable: false },
        getAccountSync()?.defaultRole === 'sales_manager' ? { key: "owner", label: "Owner", sortable: false } : undefined,
      ],
      toDeleteItem: null,
      selectedUserIds: []
    };
  },
  apollo: {
    campaigns: {
      query: LIST_CAMPAIGNS,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          // pagination
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const whereAttributes = [];
        if (this.search) {
          whereAttributes.push({
            name: {
              _ilike: `%${this.search}%`
            }
          });
        }
        if (this.selectedStatus) {
          whereAttributes.push({
            status: {
              _eq: this.selectedStatus
            }
          });
        }
        if (this.selectedUserIds.length > 0) {
          whereAttributes.push({
            owner_id: {
              _in: this.selectedUserIds
            }
          });
        }

        if (whereAttributes.length > 0) {
          vars.where = {
            _and: whereAttributes
          };
        }

        return vars;
      },

      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.campaigns_aggregate.aggregate.totalCount;
        }
      }
    },
    users: {
      query: LIST_AVAILABLE_USERS,
      variables(){
        return {
          adminId: getAccountSync()?.userId,
        }
      }
    }
  },
  computed: {
    // items remaps campaigns for template
    items() {
      const d = this.campaigns.map(campaign => {
        return {
          id: campaign.id,
          name: campaign.name,
          status: campaign.status,
          audience: campaign?.audience || "-",
          number_of_clicks: campaign.number_of_clicks,
          number_of_opens: campaign.number_of_opens,
          ctr: campaign.ctr,
          open_rate: campaign.open_rate,
          sent_at: campaign.sent_at,
          external_link: campaign.external_link,
          template_name: campaign?.template?.name,
          template_id: campaign?.template?.id,
          owner: getOwnerData(campaign?.owner)
        };
      });
      return d;
    },
    toDeleteCampaign() {
      if (!this.toDeleteItem) {
        return null;
      }
      const c = this.items.find(i => i.id === this.toDeleteItem);
      if (!c) {
        return null;
      }
      return c;
    }
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_CAMPAIGN,
          variables: {
            id
          }
        });
        this.$toast.success(`Campaign deleted`);
        this.toDeleteItem = null;
      } catch (error) {
        this.$toast.error(`Failed to delete campaign : ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
